import { render, staticRenderFns } from "./grafico-svg.vue?vue&type=template&id=3af6d03c&scoped=true&"
import script from "./grafico-svg.vue?vue&type=script&lang=js&"
export * from "./grafico-svg.vue?vue&type=script&lang=js&"
import style0 from "./grafico-svg.vue?vue&type=style&index=0&id=3af6d03c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6d03c",
  null
  
)

export default component.exports